import { render, staticRenderFns } from "./Spinner-loader.vue?vue&type=template&id=b91f9e1e&scoped=true&"
import script from "./Spinner-loader.vue?vue&type=script&lang=js&"
export * from "./Spinner-loader.vue?vue&type=script&lang=js&"
import style0 from "./Spinner-loader.vue?vue&type=style&index=0&id=b91f9e1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91f9e1e",
  null
  
)

export default component.exports